module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Battery-full-7538bf2888e40f595bd2fcf9a9d1695e.svg";